import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import LoginForm from "@/components/LoginForm";

export default function Connexion() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  return (
    <LoginForm
      title="Connexion"
      subtitle="Retrouve tes commandes et gère ton compte La Fribue."
      onSuccess={() => navigate(params.get("redirect") || "/")}
    />
  );
}
